module.exports = "/_next/static/images/banner-ae4bca3a3b93af4e49b282092ec918f5.jpg";